var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnbM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C18.6279 0 24 5.37212 24 12C24 18.6279 18.6279 24 12 24C5.37212 24 0 18.6279 0 12C0 5.37212 5.37212 0 12 0Z",
    fill: "#F0B90B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.595 11.9995L6.60366 15.1726L9.29981 16.7591V18.6168L5.02577 16.1101V11.0716L6.595 11.9995ZM6.595 8.82644V10.6755L5.02481 9.74663V7.8976L6.595 6.96875L8.17289 7.8976L6.595 8.82644ZM10.4258 7.8976L11.996 6.96875L13.5738 7.8976L11.996 8.82644L10.4258 7.8976Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7298 14.5149V12.6572L9.29999 13.5861V15.4351L7.7298 14.5149ZM10.426 17.4245L11.9961 18.3534L13.574 17.4245V19.2736L11.9961 20.2024L10.426 19.2736V17.4245ZM15.826 7.8976L17.3961 6.96875L18.974 7.8976V9.74663L17.3961 10.6755V8.82644L15.826 7.8976ZM17.3961 15.1726L17.4048 11.9995L18.975 11.0707V16.1091L14.701 18.6159V16.7582L17.3961 15.1726Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2701 14.5149L14.6999 15.4351V13.5861L16.2701 12.6572V14.5149Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2702 9.48437L16.2788 11.3421L13.575 12.9286V16.1094L12.0048 17.0296L10.4346 16.1094V12.9286L7.73076 11.3421V9.48437L9.30768 8.55553L11.9952 10.1498L14.699 8.55553L16.2769 9.48437H16.2702ZM7.7298 6.31226L11.9961 3.79688L16.2702 6.31226L14.7 7.24111L11.9961 5.64687L9.29999 7.24111L7.7298 6.31226Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbM);
export default __webpack_public_path__ + "static/media/bnb-m.9efdb8390f3991943191273b8f8d771e.svg";
export { ForwardRef as ReactComponent };